import { createSlice } from "@reduxjs/toolkit";

interface FormSubmittedProps {
  isFormSubmitted: number;
}

const initialState: FormSubmittedProps = {
  isFormSubmitted: 0,
};

const FormSubmitted = createSlice({
  name: "formsubmitted",
  initialState,
  reducers: {
    setIsFormSubmitted(state, action) {
      state.isFormSubmitted = action.payload;
    },
  },
});

export default FormSubmitted.reducer;

export const { setIsFormSubmitted } = FormSubmitted.actions;
